import { render, staticRenderFns } from "./SidebarChild.vue?vue&type=template&id=93d047d0"
import script from "./SidebarChild.vue?vue&type=script&lang=js"
export * from "./SidebarChild.vue?vue&type=script&lang=js"
import style0 from "./SidebarChild.vue?vue&type=style&index=0&id=93d047d0&prod&lang=scss"
import style1 from "./SidebarChild.vue?vue&type=style&index=1&id=93d047d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports